import { useState } from "react";
import styled from "@emotion/styled";
import { Button, TextField, Typography, CircularProgress } from "@mui/material";
import axios from "axios";

const AUTH_LOGIN_URL =
  import.meta.env.VITE_AUTH_LOGIN_URL ||
  `${import.meta.env.VITE_PROFITS_WS_URL}/auth/login`;

export const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const { data } = await axios.post(AUTH_LOGIN_URL, { username, password });
      localStorage.setItem(
        import.meta.env.VITE_AUTH_TOKEN_KEY || "arbitrage_token",
        data.access_token
      );
      window.location.reload();
    } catch (err: any) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography variant="h6" style={{ color: "white" }}>
        Crypto App
      </Typography>
      <Form onSubmit={handleLogin}>
        <TextField
          label="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          autoFocus
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
        />
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading || !username || !password}
        >
          {loading ? <CircularProgress size={24} /> : "Login"}
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.theme.palette.background.default};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  flex: 1;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  width: 20rem;
`;
